import Vue from 'vue';
import Vuex from 'vuex'; 
import conversation from './modules/conversation'
import group from './modules/group'
import user from './modules/user'
import video from './modules/video'
import friend from './modules/friend'
import blacklist from './modules/blacklist'
import groupLive from './modules/groupLive'
import {Message} from 'element-ui'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        creaDas: JSON.parse(sessionStorage.getItem('creaDas')) || '', //初始化类型的id 
        keys: JSON.parse(sessionStorage.getItem('keys')) || '', //tab--key值
        disOpen: JSON.parse(sessionStorage.getItem('disOpen')) || false, //tab--key值
        buttonPermission: JSON.parse(sessionStorage.getItem('buttonPermission')) || '', //菜单动态权限
        menuPermission: JSON.parse(sessionStorage.getItem('menuPermission')) || '', //菜单动态权限
        // name: JSON.parse(sessionStorage.getItem('name')) || '', //登录头部名字
        // admin: JSON.parse(sessionStorage.getItem('admin')) || '', //admin角色
        // userOpen: JSON.parse(sessionStorage.getItem('userOpen')) || '', //开关
        // topic: JSON.parse(sessionStorage.getItem('topic')) || '', //专题
        // currt: JSON.parse(sessionStorage.getItem('currt')) || '', //专题页数
        // token: JSON.parse(sessionStorage.getItem('token')) || '',//获取token
        // voteId: JSON.parse(sessionStorage.getItem('voteId')) || '', // 活动id
        optionImg: JSON.parse(sessionStorage.getItem('optionImg')) || '', //活动添加选项的封面图
        current: Date.now(), // 当前时间
        intervalID: 0,
        message: undefined,
    },

    getters: {
        hidden(state) {
            // eslint-disable-next-line no-unused-vars
            const temp = state.current
            if (typeof document.hasFocus !== 'function') {
                return document.hidden
            }
            return !document.hasFocus()
        }
    },
    mutations: {
        getCreaDas(state, actions) {
            state.creaDas = actions;
            sessionStorage.setItem('creaDas', JSON.stringify(state.creaDas))

        },
        //tab--key值--专题
        submitKey(state, actions) {
            state.keys = actions;
            sessionStorage.setItem('keys', JSON.stringify(state.keys))
        },
        // 活动id
        voteDetail(state, actions) {
            state.voteId = actions;
            sessionStorage.setItem('voteId', JSON.stringify(state.voteId))
        },
        // 活动----添加选项封面图
        voteOptionImg(state, actions) {
            state.optionImg = actions;
            sessionStorage.setItem('optionImg', JSON.stringify(state.optionImg))
        },
        // 编辑-禁用-新闻
        editDisabled(state, actions) {
            state.disOpen = actions;

            sessionStorage.setItem('disOpen', JSON.stringify(state.disOpen))
        },

        // 导航菜单权限：
        getMenu(state, actions) {
            state.menuPermission = actions;
            sessionStorage.setItem('menuPermission', JSON.stringify(state.menuPermission))
            console.log(state.menuPermission,'导航菜单权限')
        },
        // 按钮权限
        getPermission(state, actions) {
            state.buttonPermission = actions;
            sessionStorage.setItem('buttonPermission', JSON.stringify(state.buttonPermission))
            console.log(state.buttonPermission,'页面按钮权限')
        },

        // 登录头部名字：
        getName(state, actions) {
            state.name = actions;
            sessionStorage.setItem('name', JSON.stringify(state.name))
        },
        getAdmin(state, actions) {
            state.admin = actions;
            sessionStorage.setItem('admin', JSON.stringify(state.admin))
        },
        getOpen(state, actions) {
            state.userOpen = actions;
            sessionStorage.setItem('userOpen', JSON.stringify(state.userOpen))
        },
        getTopics(state, actions) {
            state.topic = actions;
            sessionStorage.setItem('topic', JSON.stringify(state.topic));


        },
        getTC(state, actions) {
            state.currt = actions;
            sessionStorage.setItem('currt', JSON.stringify(state.currt));

        },
        getToken(state, actions) {
            state.token = actions;
            sessionStorage.setItem('token', JSON.stringify(state.token))
        },
        
        startComputeCurrent(state) {
            state.intervalID = setInterval(() => {
                state.current = Date.now()
            }, 500)
        },
        stopComputeCurrent(state) {
            clearInterval(state.intervalID)
            state.intervalID = 0
        },
        showMessage(state, options) {
            if (state.message) {
                state.message.close()
            }
            state.message = Message({
                message: options.message,
                type: options.type || 'success',
                duration: options.duration || 2000,
                offset: 40
            })
        }

    },
    modules: {
        conversation,
        group,
        friend,
        blacklist,
        user,
        video,
        groupLive,
    },
    actions: {





    }
})